export default class {
	constructor() {
	  this.hover = '.js-hoverRandom';
	  this.isCold = 'is-cold';
	  this.isWarm = 'is-warm';
	  this.init();
	}

		init() {
		const links = document.querySelectorAll(this.hover);
		const self = this;
		links.forEach(function(link) {
			link.addEventListener('mouseover', function() {
				this.classList.remove(self.isCold, self.isWarm);

				const classes = [self.isCold, self.isWarm];
				const selectedClass = classes[Math.floor(Math.random() * classes.length)];
				this.classList.add(selectedClass);
			});
			link.addEventListener('mouseleave', function() {
				this.classList.remove(self.isCold, self.isWarm);
			});
		});
	}
}